import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Categories } from "@/components/landing/Categories";
import { WhyUs } from "@/components/landing/WhyUs";
import { AppCta } from "@/components/landing/AppCta";
import { Faq } from "@/components/landing/Faq";

export default function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Categories />
        <WhyUs />
        <AppCta />
        <Faq />
      </main>
    </>
  );
}
